import Injector from 'vue-inject';
import Debug from '@/util/debug';

const debug = Debug('service:StatusFlow');

export const STATUS_FLOW_DEFAULT = 'DEFAULT'; // eslint-disable-line no-unused-vars
export const STATUS_FLOW_ASAP = 'ASAP'; // eslint-disable-line no-unused-vars

export const CREATIVE_FLOW_CLASS_ONBOARDING = 'SeventySeven\\FbAdManager\\Classes\\OnboardingCreativeFlow';

export default class StatusFlowService {
  constructor(adApiService) {
    this.adApiService = adApiService;
    this.statusFlows = null;
    this.error = null;
  }

  loadStatusFlowsFromApi() {
    debug.info('loadStatusFlowsFromApi');
    return this.adApiService.getStatusFlows()
      .then(statusFlows => this.statusFlows = statusFlows)
      .catch(err => {
        debug.error('error while loading from api: %o', err);
        this.error = err;
        throw err;
      });
  }

  getStatusFlows() {
    debug.info('getStatusFlows err: %o, statusFlows: %o', this.error, this.statusFlows);
    if (this.error !== null) {
      return new Promise((resolve, reject) => reject(this.error));
    } else if (this.statusFlows) {
      return new Promise(resolve => resolve(this.statusFlows));
    }

    return this.loadStatusFlowsFromApi();
  }

  isStatusFlowAvailable(flowTag) {
    return this.getStatusFlows()
      .then(flows => flows.findIndex(s => s.tag === flowTag) !== -1);
  }

  getDefault() {
    return this.getStatusFlows()
      .then(flows => {
        const flow = flows.find(f => f.isDefault);
        if (flow) return flow;

        if (flows[0]) {
          return flows[0];
        }

        throw new Error('no status flows');
      });
  }
}

Injector.service('statusFlowService', ['adApiService'], StatusFlowService);



// WEBPACK FOOTER //
// ./src/services/StatusFlowService.js